<ng-template [ngIf]="button.url && button.source != 3">
  <ion-button type="button" 
  [download]="button.download ? '' : null"
  [href]="button.url" 
  [expand]="button.expand" 
  [fill]="button.fill" 
  [size]="button.size"
  [target]="button.target"
  [color]="button.color">{{button.text}}</ion-button>
</ng-template>


<ng-template [ngIf]="button.source == 3">
  <ion-button type="button" 
  (click)=go(button.url)
  [expand]="button.expand" 
  [fill]="button.fill" 
  [size]="button.size"
  [target]="button.target"
  [color]="button.color">{{button.text}}</ion-button>
</ng-template>

